import React from 'react';

import './NoContentBanner.scss';

export default function NoContentBanner(props) {
  const text =
    props.type === 'article'
      ? [
          `Artikelen van ${props.user}`,
          `${props.user} heeft nog geen article's`
        ]
      : [`Video's van ${props.user}`, `${props.user} heeft nog geen video's`];

  return (
    <section id="noContentBanner">
      <div>
        <p>{text[0]}</p>
        <p>{text[1]}</p>
      </div>
    </section>
  );
}
